import Phaser from "phaser";
import type { BrickCellKind } from "../data/ChapterData.js";
import { PALETTE } from "../themes/palette.js";
import { TYPO } from "../ui/uiTokens.js";
import { CIRCUIT_LABEL_BACKGROUND } from "./brickVisualTextures.js";

const BRICK_LABEL_SHADOW = "#020607";

export function applyBrickLabelTextStyle(
  label: Phaser.GameObjects.Text,
  kind: BrickCellKind,
  isCircuitVisual: boolean,
  dimGoldVisual: boolean,
): void {
  if (kind === "mystery" && isCircuitVisual) {
    label
      .setFontSize(TYPO.label)
      .setColor("#c9ad63")
      .setStroke("#020607", 2)
      .setBackgroundColor(CIRCUIT_LABEL_BACKGROUND)
      .setShadow(0, 1, BRICK_LABEL_SHADOW, 1, true, false)
      .setPadding(0, 0, 0, 0);
    return;
  }
  if (kind === "mystery") {
    label
      .setFontSize(TYPO.large)
      .setColor("#d2a24a")
      .setStroke("#160f04", 2)
      .setBackgroundColor("#000000")
      .setShadow(0, 1, BRICK_LABEL_SHADOW, 2, true, true)
      .setPadding(5, 1, 5, 1);
    return;
  }
  if (dimGoldVisual) {
    label
      .setFontSize(TYPO.label)
      .setColor("#a98642")
      .setStroke("#020607", 1)
      .setBackgroundColor(CIRCUIT_LABEL_BACKGROUND)
      .setShadow(0, 0, BRICK_LABEL_SHADOW, 0, false, false)
      .setPadding(0, 0, 0, 0);
    return;
  }
  if (isCircuitVisual) {
    label
      .setFontSize(TYPO.label)
      .setColor("#87d2c6")
      .setStroke("#020607", 1)
      .setBackgroundColor(CIRCUIT_LABEL_BACKGROUND)
      .setShadow(0, 0, BRICK_LABEL_SHADOW, 0, false, false)
      .setPadding(0, 0, 0, 0);
    return;
  }
  label
    .setFontSize(TYPO.display)
    .setColor(PALETTE.textBright)
    .setStroke("#000000", 5)
    .setBackgroundColor("#000000")
    .setShadow(0, 1, BRICK_LABEL_SHADOW, 3, true, true)
    .setPadding(12, 2, 12, 2);
}
